import React from 'react'
import styled from 'styled-components'
import Nav from './component/nav/index'
import Feat1 from './component/feat1/index'
import Feat2 from './component/feat2/index'
import Feat3 from './component/feat3/index'
import More from './component/more/index'
import Intro from './component/intro/index'
import Footer from './component/footer/index'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow-x: hidden;
`

const About = () => {
  return (
    <PageContainer>
      <Nav></Nav>
      <Feat1></Feat1>
      <Feat2></Feat2>
      <Feat3></Feat3>
      <More></More>
      <Intro></Intro>
      <Footer></Footer>
    </PageContainer>
  )
}

export default About
